import {
    FETCH_ALL_SURVEY_QUESTION_SUCCESS,
    SHOW_SURVEY_QUESTION_LOADER,
    HIDE_SURVEY_QUESTION_LOADER,
    SHOW_SURVEY_QUESTION_MESSAGE,
    CLEAR_SESSION,
} from 'constants/ActionTypes';

const INIT_STATE = {
    loader: false,
    alertMessage: '',
    showMessage: false,
    allSurveyQuestion: [],
    surveyQuestionList: [],
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case CLEAR_SESSION: {
            return {
                ...INIT_STATE,
            };
        }
        case FETCH_ALL_SURVEY_QUESTION_SUCCESS: {
            return {
                ...state,
                loader: false,
                allSurveyQuestion: action.payload,
                surveyQuestionList: action.payload,
            };
        }
        case SHOW_SURVEY_QUESTION_MESSAGE: {
            return {
                ...state,
                alertMessage: action.payload,
                showMessage: true,
                loader: false
            };
        }
        case SHOW_SURVEY_QUESTION_LOADER: {
            return { ...state, loader: true };
        }
        case HIDE_SURVEY_QUESTION_LOADER: {
            return { ...state, loader: false };
        }
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./reducers/SurveyQuestion.js